import * as React from 'react';
/**
 *
 * Original name: Family Room
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=47294%3A3740
 *
 */
export const FamilyRoomFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M8.865 11.78c0-1.24-1.01-2.25-2.25-2.25H5.64c.19-1.47.695-2.62 1.505-3.43 1.06-1.06 2.69-1.6 4.85-1.6 2.16 0 3.79.54 4.85 1.6.81.81 1.315 1.96 1.505 3.43h-.97c-1.24 0-2.25 1.01-2.25 2.25v1.34H8.865v-1.34Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M16.635 11.78c0-.415.335-.75.75-.75H20v7h-1.5v2H17v-2H7v2H5.5v-2H4v-7h2.615c.415 0 .75.335.75.75v2.84h9.27v-2.84Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
